import React from 'react';
import { Query } from '@apollo/client/react/components';
import { useSearchParams } from 'react-router-dom';

import CurrentUserFollowersList from 'buyside/graphql/queries/CurrentUserFollowersList';

import MembersIndexCardLoading from 'buyside/components/presentation/MembersIndexPage/MembersIndexCard/membersIndexCardLoading';
import UserFollowersList from 'buyside/components/presentation/UserAccount/UsersFollowingYou/userFollowersList';

import { validatePageParam } from 'buyside/util/numbers';

const UserFollowersListContaier = () => {
  const [searchParams] = useSearchParams();
  const page = validatePageParam(searchParams);

  return (
    <Query query={CurrentUserFollowersList} variables={{ page }}>
      {({ error, loading, data = {} }) => {
        if (loading)
          return [...Array(3)].map((_, idx) => (
            <MembersIndexCardLoading key={`following-skeleton-${idx}`} />
          ));
        if (error) throw error;
        return (
          <UserFollowersList
            followersList={
              data.currentUser.followersList ? data.currentUser.followersList.edges : null
            }
            activeFollowersCount={data.currentUser.activeFollowersCount}
            canViewUserDetails={data.currentUser.canViewUserDetails}
          />
        );
      }}
    </Query>
  );
};

export default UserFollowersListContaier;
